<script setup>
const props = defineProps({
    hit: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <MessLink :href="hit.url" class="block-algolia-hit" :label="hit.title" v-posthog-capture="{ name: 'search_result_clicked', properties: { result_url: hit.url, result_title: hit.title, result_type: hit.model || hit.type } }">
        <strong class="h6" v-if="hit.model || hit.type">{{ hit.model || hit.type }}</strong>
        <MessHtml class="title h3" v-if="hit.title" :html="hit.title" />
    </MessLink>
</template>

<style lang="scss">
html {
    body {
        .block-algolia-hit {
            user-select: auto;
            transition: 250ms ease-in-out;

            &:hover {
                .title {
                    text-decoration: none;
                }
            }

            .h6 {
                font-size: 0.75rem;
                text-transform: uppercase;
                color: var(--dark-pink);
                letter-spacing: 0.0375rem;
                font-weight: 700;
                font-family: var(--font-hubspot-sans);
            }

            .title {
                color: var(--magenta);
                font-size: 1.25rem;
                font-weight: 400;
                line-height: 1.5;
                letter-spacing: 0.2px;
                display: flex;
                width: fit-content;
                font-family: var(--font-hubspot-serif);
                text-decoration: underline dotted #a55c87;
                text-underline-offset: 3px;
                text-decoration-thickness: 6%;
            }
        }
    }
}
</style>
